import Cookies from 'js-cookie'

export default class NewsletterInline extends HTMLElement {
    private formElement: HTMLFormElement | null = null
    private titleElement: HTMLElement | null = null
    private buttonElement: HTMLButtonElement | null = null
    private inputElement: HTMLInputElement | null = null

    private cloudflareKlaviyoUrl: string = 'https://rodeo-klaviyo-subscribe.hi-f17.workers.dev'

    constructor() {
        super()

        this.formElement = this.querySelector('form')
        this.titleElement = this.querySelector('h5')
        this.buttonElement = this.querySelector('button')
        this.inputElement = this.querySelector('input[type="email"]')

        if (this.formElement) {
            this.formElement.addEventListener('submit', this.handleFormSubmit.bind(this))
        }
    }

    async handleFormSubmit(evt: Event) {
        evt.preventDefault()

        if (this.buttonElement) {
            this.buttonElement.textContent = 'Submitting...'
            this.buttonElement.disabled = true
        }

        const form = evt.target as HTMLFormElement
        form.classList.add('pointer-events-none')

        const formData = new FormData(form)
        // Handle Shopify's contact[email] format
        const email = formData.get('contact[email]') || ''

        const body = {
            email: email,
        }

        try {
            const response = await fetch(this.cloudflareKlaviyoUrl, {
                method: 'POST',
                body: JSON.stringify(body),
            })

            const data = await response.json()

            if (data.success) {
                if (this.titleElement) {
                    this.titleElement.textContent = 'Thank you for subscribing!'
                }
                if (this.inputElement) {
                    this.inputElement.value = ''
                }
            }
        } catch (error) {
            // Check if this is a 409 error (already subscribed)
            if ((error as any).status === 409) {
                if (this.titleElement) {
                    this.titleElement.textContent = 'You are already subscribed!'
                }
            } else {
                // Handle other errors
                if (this.titleElement) {
                    this.titleElement.textContent = 'Something went wrong. Please try again later.'
                }
            }
        } finally {
            // Re-enable the form after a short delay
            setTimeout(() => {
                if (this.buttonElement) {
                    const buttonText = this.buttonElement.getAttribute('data-original-text') || 'Submit'
                    this.buttonElement.textContent = buttonText
                    this.buttonElement.disabled = false
                }
                form.classList.remove('pointer-events-none')
            }, 2000)
        }
    }

    connectedCallback() {
        // Store original button text for reset
        if (this.buttonElement) {
            this.buttonElement.setAttribute('data-original-text', this.buttonElement.textContent || 'Submit')
        }
    }
}

customElements.define('shop-newsletter-inline', NewsletterInline)
